import { SupportedLanguagesType } from './createSupportedLanguages';

export interface SettingsSlice {
  durationEstimated?: boolean;
  textLocale: string;
  textLocales: string[];
  languages: string[];
  mediumLocale: string;
  mediumLocales: string[];
  subtitleLocale: string;
  subtitleLocales: string[];
  supportedLanguages: SupportedLanguagesType;
  languageAutoDetect: boolean;
  subtitles: boolean;
  playbackSpeed: number;
  auditoryFeedback: boolean;
  visualFeedback: boolean;
  askName?: boolean;
  autoPlay?: boolean;
  certificateUrl?: string;
  learnerPortalUrl?: string;
  featureShowIssueReporting?: boolean;
  featureShowHotline?: boolean;
  featureShowReviewStep?: boolean;
  featureShowCertificate?: boolean;
  featureShowSocialShare?: boolean;
  featureShowAbout?: boolean;
  featureShowLlama?: boolean;
  featureShowChatbot?: boolean;
  featureShowNextTraining?: boolean;
  fasterPlaybackSpeed?: boolean;
  featureFocus?: boolean;
  disclaimer?: string | undefined;
  onboarding?: boolean | null | undefined;
  shouldDisplayCourseDurationCard?: boolean;
  shouldDisplayTimeRemainingPill?: boolean;
  setShouldDisplayTimeRemainingPill(display: boolean): void;
  darkMode?: string;
  setLocale(locale: string): void;
  setTextLocale(
    locale: string,
    subtitles?: boolean,
    isOnboarding?: boolean
  ): void;
  setMediumLocale(locale: string): void;
  setSubtitles(subtitles: boolean): void;
  setPlaybackSpeed(speed: number): void;
  setAuditoryFeedback(auditoryFeedback: boolean): void;
  setVisualFeedback(visualFeedback: boolean): void;
  setDarkMode(darkMode: string): void;
  setAutoPlay(autoPlay: boolean): void;
  setSubtitleLocale(locale: string): void;
}
